/* angular:styles/component:css;6b730708b2bae6a6d890caf85bd0ef9847897486fb2e3ef3189ba19641dd1b16;/src/src/app/edge/live/common/weather/mini-widget/mini-widget.ts */
.weather-widget {
  width: 100%;
  max-width: 16em;
  min-width: 13em;
  justify-self: start;
  align-self: start;
  padding-left: 1rem;
}
.weather-main {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 0.75rem;
}
.weather-icon {
  font-size: 6em;
  flex-shrink: 0;
}
.weather-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.temperature {
  font-size: 2em;
  line-height: 1;
  font-family: "FeneconHeadline";
}
.sunshine-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
}
.sunshine-duration-icon {
  flex-shrink: 0;
}
/*# sourceMappingURL=mini-widget.css.map */
